import React from 'react';
import './Check.scss';

const Check = ({ active }) => (
  <span className={`c-check ${active ? 'active' : null}`} />
);

export default Check;
